module.exports = __webpack_public_path__ + "static/media/visa-logo.2dbdd57c.png";